var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(_vm.avatarStyle)},[(_vm.hasStatus)?_c('span',{staticClass:"avatar-status",class:_vm.statusClassName}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }